// 查询能力诊断试卷详情
export const POST_QUERY_PAPERS = "/api/exam/queryPapers";
// 查询课程试卷详情
export const POST_QUERY_BY_ID_COURSE_PAPERS = "/api/exam/queryByIdCoursePapers";
// 查询章节试卷详情
export const POST_QUERY_CHAPTER_PAPERS = "/api/exam/queryChapterPapers";
// 查询认证能力|模拟练习试卷详情
export const POST_QUERY_GENERAL_PAPERS = "/api/exam/queryGeneralPapers";
// 保存试卷
export const POST_PAPERS_SUBMIT = "/api/exam/papersSubmit";
// 查询试卷答题记录详情
export const POST_QUERY_BYID_PAPERS = "/api/exam/queryByIdPapers";
// 维度推荐课查询
export const POST_QUERY_COURSE_PAPERS = "/api/exam/queryCoursePapers";
// 查询能力诊断成绩详情
export const POST_EXAM_MY_PAPERS = "/api/exam/myExamPapers";

// 答题记录列表
export const POST_EXAM_QUERY_STUDENT_PAPERS = "/api/exam/queryStudentPapers";
